import React, { useEffect, useState } from "react";
import { Card, Spinner } from "@/components/ui";
import { endpoints } from "@/lib/api";
import { DollarSign } from "lucide-react";

function Window({ label, s, testid }) {
  return (
    <div className="p-4 rounded-md" style={{ background: "rgba(21,42,85,0.35)", border: "1px solid rgba(255,255,255,0.06)" }} data-testid={testid}>
      <div className="text-[10px] uppercase tracking-[0.16em] text-white/40 mb-2">{label}</div>
      <div className="font-display text-3xl text-gold mb-3" data-testid={`${testid}-total`}>${s.total_cost_usd.toFixed(2)}</div>
      <div className="flex justify-between text-[12px] text-white/60"><span>LLM calls</span><span className="font-mono text-white">{s.llm.calls} · ${s.llm.cost_usd.toFixed(2)}</span></div>
      <div className="flex justify-between text-[12px] text-white/60 mt-1"><span>Tavily calls</span><span className="font-mono text-white">{s.tavily.calls} · ${s.tavily.cost_usd.toFixed(2)}</span></div>
    </div>
  );
}

export function CostTracker({ scope = "me", title = "Cost tracker" }) {
  const [d, setD] = useState(null);
  useEffect(() => { endpoints.usageSummary(scope).then((r) => setD(r.data)).catch(() => setD(null)); }, [scope]);
  return (
    <Card hover={false} data-testid={`cost-tracker-${scope}`}>
      <div className="overline mb-4 flex items-center gap-2"><DollarSign size={12} /> {title}</div>
      {!d ? <Spinner /> : (
        <>
          <div className="grid grid-cols-2 gap-3">
            <Window label="Last 7 days" s={d.last_7d} testid={`cost-7d-${scope}`} />
            <Window label="Last 30 days" s={d.last_30d} testid={`cost-30d-${scope}`} />
          </div>
          <div className="text-[10.5px] text-white/35 mt-3">Tracked from every billed LLM and Tavily call (cache hits excluded). LLM cost priced from actual token volume.</div>
        </>
      )}
    </Card>
  );
}
